// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/NotFound.tsx
// Version: v1.0.1
// Description: 404 Error Page mit Navigation und Quick Links
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../components/ui/Button.tsx';
import { useLanguage } from '../lang/index.lang.tsx';

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  // Optional: Log 404 for analytics
  useEffect(() => {
    console.warn(`404 Error: Page not found - ${location.pathname}`);
  }, [location.pathname]);

  return (
    <div className="min-h-[600px] bg-gray-50 flex items-center justify-center px-4 py-16">
      <div className="max-w-2xl mx-auto text-center">
        
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-8xl lg:text-9xl font-bold text-gray-200 select-none">
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
            Seite nicht gefunden
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            Die angeforderte Seite konnte nicht gefunden werden.
          </p>
          <p className="text-sm text-gray-500 font-mono bg-gray-100 px-3 py-1 rounded inline-block">
            {location.pathname}
          </p>
        </div>

        {/* Suggestions */}
        <div className="mb-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Das könnten Sie versuchen:
          </h3>
          <ul className="text-gray-600 space-y-2 text-left max-w-md mx-auto">
            <li className="flex items-start">
              <span className="text-[#37acdc] mr-2">•</span>
              Überprüfen Sie die URL auf Tippfehler
            </li>
            <li className="flex items-start">
              <span className="text-[#37acdc] mr-2">•</span>
              Verwenden Sie die Navigation oben
            </li>
            <li className="flex items-start">
              <span className="text-[#37acdc] mr-2">•</span>
              Kehren Sie zur Startseite zurück
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="mb-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Beliebte Seiten:
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/" 
              className="text-[#37acdc] hover:text-blue-800 underline transition-colors"
            >
              Startseite
            </Link>
            <Link 
              to="/services" 
              className="text-[#37acdc] hover:text-blue-800 underline transition-colors"
            >
              Services
            </Link>
            <Link 
              to="/partners" 
              className="text-[#37acdc] hover:text-blue-800 underline transition-colors"
            >
              Partner
            </Link>
            <Link 
              to="/about" 
              className="text-[#37acdc] hover:text-blue-800 underline transition-colors"
            >
              Über uns
            </Link>
            <Link 
              to="/careers" 
              className="text-[#37acdc] hover:text-blue-800 underline transition-colors"
            >
              Karriere
            </Link>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            variant="estata" 
            size="medium" 
            to="/"
            className="inline-flex items-center"
          >
            <svg 
              className="w-5 h-5 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" 
              />
            </svg>
            Zur Startseite
          </Button>
          
          <button 
            onClick={() => window.history.back()}
            className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors inline-flex items-center"
          >
            <svg 
              className="w-5 h-5 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M10 19l-7-7m0 0l7-7m-7 7h18" 
              />
            </svg>
            Zurück
          </button>
        </div>

        {/* Contact Info */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Falls das Problem weiterhin besteht, kontaktieren Sie uns unter{' '}
            <a 
              href="mailto:info@estata.de" 
              className="text-[#37acdc] hover:text-blue-800 underline"
            >
              info@estata.de
            </a>
          </p>
        </div>

      </div>
    </div>
  );
};

export default NotFound;